import { render, staticRenderFns } from "./CikkMegosztas.vue?vue&type=template&id=30244dd8&"
import script from "./CikkMegosztas.vue?vue&type=script&lang=js&"
export * from "./CikkMegosztas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports